import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import { getTemplateDetail, updateTemplateDetail } from "../../../../utils/sociaMediaIconsApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import SocialIconsTemplateWidget from "../../../../components/Apps/SocialMediaIcons/Template/SocialIconsTemplateWidget";

//Import Tabs
import IconsTab from "../../../../components/Apps/SocialMediaIcons/IconsTab";
import LayoutTab from "../../../../components/Apps/SocialMediaIcons/LayoutTab";
import StyleTab from "../../../../components/Apps/SocialMediaIcons/StyleTab";

export default function EditSocialMediaIcons() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeSection, setActiveSection] = useState("Icons");
    const [activeTemplateSection, setActiveTemplateSection] = useState("");
    const [selectedLayout, setSelectedLayout] = useState("");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Social Media Icons");
    const [newWidgetName, setNewWidgetName] = useState("");
    const { uuid } = useParams();
    const [isTemplateId, setTemplateId] = useState(null); 
    const [refreshWidgetList, setRefreshWidgetList] = useState(false);

    const [socialMediaIconsTabData, setSocialMediaIconsTabData] = useState({
        is_website_frontend: "",  
        icon_size: "32px",  
        location_type: "",   
        position_type: "",  
        icon_color: "", 
        background_color: "", 
        icon_color_on_hover: "", 
        background_color_on_hover: "", 
        icons_shape_type: "", 
        animation_type: "None", 
        opacity_size: 100, 
        opacity_on_hover_size: 100, 
        custom_css: "",   
        custom_js: "",   
    });

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateSocialMediaIconsTabData = (key, value) => {
        setSocialMediaIconsTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const menuItems = [
        { key: "Icons", icon: "icons.png", label: "Icons" },
        { key: "Layout", icon: "layout.png", label: "Layout" },
        { key: "Style", icon: "style.png", label: "Style" },
    ];

    // Fetching Tempate data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const templateResult = await getTemplateDetail(uuid);

                //check if result is exist
                if (templateResult.data) {
                    setTemplateId(uuid);
                    setWidgetName(templateResult.data.name);
                    setActiveTemplateSection(templateResult.data.template_name);
                    setSelectedLayout(templateResult.data.layout_type);
                    setSelectedTemplateImage(templateResult.data.template_image);
                    // Convert settings array to object
                    const settingsObject = templateResult.data.settings.reduce((acc, setting) => {
                        acc[setting.setting_key] = setting.setting_value;
                        return acc;
                    }, {});

                    setSocialMediaIconsTabData(settingsObject); 
                }
            } catch (error) {
                //console.error("Error fetching data:", error);
            }
        };
        
        fetchData();
    }, [uuid],setSocialMediaIconsTabData);
  
    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const extractedImageName = selectedTemplateImage.split('/').pop();

            // Convert settings object back into an array of key-value pairs
            const settingsArray = Object.entries(socialMediaIconsTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: uuid,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: extractedImageName,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                settings: settingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/social-media-icons');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

  return (
    <>
        <div className="create-goole-reviews-all">
            <div className="overlay-side-baar">
                <div className="side-baar-inner-one">
                    <ul>
                        {menuItems.map((item) => (
                            <li key={item.key}>
                                <button
                                    className={activeSection === item.key ? "active" : ""}
                                    onClick={() => setActiveSection(item.key)}
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/social-media-icons/icons//${item.icon}`}
                                        alt={`${item.key} icon`}
                                    />
                                    <span>{item.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="side-baar-inner-tow">
                    {/* Conditional Rendering for Sections */}
                    {activeSection === "Icons" && (
                        <IconsTab updateSocialMediaIconsTabData={updateSocialMediaIconsTabData} socialMediaIconsTabData={socialMediaIconsTabData} setRefreshWidgetList={setRefreshWidgetList} />
                    )}
                    {activeSection === "Layout" && (
                        <LayoutTab updateSocialMediaIconsTabData={updateSocialMediaIconsTabData} socialMediaIconsTabData={socialMediaIconsTabData}/>
                    )}
                    {activeSection === "Style" && (
                        <StyleTab updateSocialMediaIconsTabData={updateSocialMediaIconsTabData} socialMediaIconsTabData={socialMediaIconsTabData} />
                    )}
                </div>
            </div>
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/social-media-icons"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link> </h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/social-media-icons/social-media-icons.svg`} alt="social-media-icons"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/social-media-icons/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/social-media-icons" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Social Media Icons <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    <SocialIconsTemplateWidget isTemplateId={isTemplateId} socialMediaIconsTabData={socialMediaIconsTabData} refreshWidgetList={refreshWidgetList} />   
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 